<script lang="ts" setup>
import { defineProps } from 'vue'
import YellowYesGreenNoBooleanDisplay from './YellowYesGreenNoBooleanDisplay.vue'

const props = defineProps<{
  value?: boolean
}>()
</script>
<template>
  <YellowYesGreenNoBooleanDisplay :value="props.value" isRedInsteadOfYellow />
</template>
